import type { ListActions } from "src/system/module.types.ts";
import type { ClientConfig } from "src/client-config/getClientConfig.ts";
import { getAllModulesIds } from "src/system/getAllModulesIds.ts";

type ReturnType = {
  actions: ListActions<any> | { (client: ClientConfig): ListActions<any> };
};

export const fetchResourceListActionsConfig = async ({
  resource,
  clientConfig,
}: {
  resource: string;
  clientConfig: ClientConfig;
}): Promise<ListActions<any>> => {
  const modules: string[] = getAllModulesIds();
  const lists = import.meta.glob("../admin/modules/*/lists/*/actions.tsx");

  for (let i = 0; i < modules.length; i++) {
    const moduleId = modules[i];
    const importPath = `../admin/modules/${moduleId}/lists/${resource}/actions.tsx`;

    if (Object.keys(lists).includes(importPath)) {
      const config = ((await lists[importPath]()) as ReturnType).actions;
      return typeof config === "function" ? config(clientConfig) : config;
    }
  }

  return {};
};
